export default __webpack_public_path__ + "assets/327e88b951b729424b7d5c3a3a0d9a5c.svg";